<template>
  <div ref="container" class="xl:col-span-8">
    <div class="form-container max-w-2xl xl:max-w-xl text-center">
      <step-title :title="'Edastamise vorm'"/>
      <calculator-contact-form  @messageSent="messageSent"/>
      <calculator-selected-features/>
    </div>
  </div>
</template>

<script>
import {gsap} from "gsap";
import StepTitle from "@/components/calculator-steps/utils/StepTitle";
import CalculatorContactForm from "@/components/calculator-steps/calculator-end/CalculatorContactForm";
import CalculatorSelectedFeatures from "@/components/calculator-steps/calculator-end/CalculatorSelectedFeatures";


export default {
  name: "CalculatorStepSix",
  components: {
    StepTitle,
    CalculatorContactForm,
    CalculatorSelectedFeatures
  },
  computed: {
    target: function () {
      return this.$refs['container']
    }
  },
  methods: {
    messageSent(){
      this.$emit('messageSent')
    }
  },
  mounted() {
    gsap.set(this.target, {autoAlpha: 0, y: -50})
    gsap.to(this.target, {autoAlpha: 1, y: 0, ease: 'slow'})
  },
};
</script>

<style>
@media (max-width: 1280px) {
  .form-container {
    margin: 0 auto;
  }
}
</style>
